(()=>{
"use strict";

if(window.CCXFrequency10){
  window.CCXFrequency10.init();
  return;
}

const mounted=new Map;
let config=null,products={},ui={},lastTrigger=null;

const one=selector=>document.querySelector(".ccx10 "+selector);
const all=selector=>[...document.querySelectorAll(".ccx10 "+selector)];

const say=(key,values={})=>(ui[key]||"").replace(
  /{+\s*(\w+)\s*}+/g,
  (_,name)=>String(values[name]??"")
);

const productDialog=()=>one("#ccx10-product-dialog");
const filmDialog=()=>one("#ccx10-film-dialog");

function pauseMedia(){
  all("video").forEach(video=>video.pause());

  const toggle=one("#ccx10-ambient-toggle");

  if(toggle){
    toggle.textContent=say("play_background");
    toggle.setAttribute("aria-label",say("play_background"));
  }
}

function openDialog(dialog,trigger){
  if(!dialog)return;

  all("dialog[open]").forEach(other=>{
    if(other!==dialog)other.close();
  });

  lastTrigger=trigger;
  pauseMedia();

  if(!dialog.open)dialog.showModal();

  document.body.classList.add("ccx10-modal-open");
  dialog.scrollTop=0;
}

function setImage(image,url,alt){
  if(!image)return;
  image.src=url;
  image.alt=alt||"";
}

function openProduct(key,trigger){
  const p=products[key];
  const dialog=productDialog();

  if(!p||!dialog)return;

  one("#ccx10-product-title").textContent=p.title;
  one("#ccx10-product-kicker").textContent=p.kicker;
  one("#ccx10-product-price").textContent=p.price;
  one("#ccx10-product-description").textContent=p.description;

  one("#ccx10-product-edition").textContent=
    say("worldwide_count",{count:p.edition})+
    (p.included?" · "+say("numbered"):"");

  const facts=one("#ccx10-product-facts");
  facts.replaceChildren();

  p.facts.forEach(value=>{
    const span=document.createElement("span");
    span.textContent=value;
    facts.append(span);
  });

  const ledger=one("#ccx10-modal-included");
  ledger.hidden=false;
  ledger.open=false;

  one("#ccx10-modal-included-copy").textContent=p.included
    ?say("eyewear_included")
    :say("accessory_included",{name:p.title});

  const jump=one("#ccx10-modal-unveil-link");

  jump.href=p.included
    ?"#ccx10-unveil"
    :"#ccx10-accessory-packaging";

  jump.hidden=!document.querySelector(jump.getAttribute("href"));

  const gallery=one("#ccx10-gallery-controls");
  gallery.replaceChildren();

  const images=p.included
    ?[
      ["front",say("front")],
      ["angle",say("angle")],
      ["side",say("side")],
      ["carl",say("carl")],
      ["oh_yes",say("oh_yes")]
    ].filter(([view])=>Boolean(p.views[view]))
    :[["front",say("side")]];

  function selectImage(index){
    setImage(
      one("#ccx10-product-image"),
      p.views[images[index][0]],
      p.title+" — "+images[index][1]
    );

    gallery.querySelectorAll("button").forEach((button,i)=>{
      button.setAttribute("aria-pressed",String(index===i));
    });
  }

  images.forEach(([view,label],index)=>{
    const button=document.createElement("button");
    button.type="button";
    button.textContent=label;
    button.setAttribute("aria-label",p.title+" — "+label);
    button.addEventListener("click",()=>selectImage(index));
    gallery.append(button);
  });

  gallery.hidden=images.length<2;
  selectImage(0);

  const form=dialog.querySelector("[data-ccx10-cart-form]");
  const submit=form.querySelector("[data-ccx10-cart-submit]");

  form.querySelector("[data-ccx10-variant]").value=p.variantId||"";
  form.hidden=p.requiresOptions;
  submit.disabled=!p.available||!p.variantId;

  const label=p.variantId
    ?p.available?say("add_to_cart"):say("sold_out")
    :say("unavailable");

  const arrow=document.createElement("span");
  arrow.setAttribute("aria-hidden","true");
  arrow.textContent="↗";

  submit.replaceChildren(
    document.createTextNode(label+" "),
    arrow
  );

  const link=dialog.querySelector("[data-ccx10-product-link]");
  link.hidden=!p.url;
  link.href=p.url||"#";

  const linkArrow=document.createElement("span");
  linkArrow.setAttribute("aria-hidden","true");
  linkArrow.textContent="↗";

  link.replaceChildren(
    document.createTextNode(
      p.requiresOptions
        ?say("choose_options")+" "
        :say("view_product")+" "
    ),
    linkArrow
  );

  openDialog(dialog,trigger);
}

function hydrate(){
  all("[data-ccx10-price]").forEach(el=>{
    const p=products[el.dataset.ccx10Price];
    if(p)el.textContent=p.price;
  });

  all("[data-ccx10-link]").forEach(el=>{
    const p=products[el.dataset.ccx10Link];

    if(p?.url){
      el.href=p.url;
      el.removeAttribute("aria-disabled");
      el.removeAttribute("tabindex");
    }else{
      el.removeAttribute("href");
      el.setAttribute("aria-disabled","true");
      el.tabIndex=-1;
    }
  });

  all('a[href^="#ccx10-"]').forEach(link=>{
    link.hidden=!document.querySelector(link.getAttribute("href"));
  });

  for(const[key,p]of Object.entries(products)){
    const slide=one("#ccx10-collector-piece-"+key);

    if(slide){
      setImage(slide.querySelector("img"),p.views.front,p.title);
      slide.dataset.name=p.title;
    }
  }

  const active=one(".ccx10-collector-piece:not([hidden])");

  if(active&&one("#ccx10-collector-piece-name")){
    one("#ccx10-collector-piece-name").textContent=active.dataset.name;
  }

  const source=one("#ccx10-full-film source");
  const ambientSource=one("#ccx10-ambient-film source");
  const videoURL=config.videoURL||ambientSource?.getAttribute("src");

  if(source&&videoURL&&source.getAttribute("src")!==videoURL){
    source.src=videoURL;
    source.parentElement.load();
  }

  if(ambientSource&&!ambientSource.getAttribute("src")&&videoURL){
    ambientSource.src=videoURL;
    ambientSource.parentElement.load();
  }

  const offset=Math.max(
    0,
    Math.min(180,Number(config.headerHeight)||0)
  );

  document.querySelectorAll(".ccx10").forEach(root=>{
    root.style.setProperty("--ccx10-header-height",offset+"px");
  });

  if(
    window.Shopify?.designMode||
    matchMedia("(prefers-reduced-motion: reduce)").matches
  ){
    pauseMedia();
  }
}

function init(force=false){
  const source=document.querySelector("[data-ccx10-config]");

  if(source){
    try{
      config=JSON.parse(source.textContent);
    }catch{
      return;
    }

    products=config.products||{};
    ui=config.ui||{};

    for(const key of ["ride","vibe"]){
      const p=products[key];

      if(p){
        p.views={
          ...p.views,
          ...Object.fromEntries(
            Object.entries(config.eyewearViews?.[key]||{})
              .filter(([,url])=>Boolean(url))
          )
        };
      }
    }

    for(const[key,p]of Object.entries(products)){
      p.facts=Object.keys(ui)
        .filter(k=>k.startsWith(key+"_fact_"))
        .map(k=>ui[k]);

      p.kicker=ui[key+"_kicker"]||"";
    }

    for(const[root,controller]of mounted){
      if(force||!root.isConnected){
        controller.abort();
        mounted.delete(root);
      }
    }

    hydrate();

    document.querySelectorAll(".ccx10").forEach(root=>{
      if(mounted.has(root))return;

      const controller=new AbortController;
      mounted.set(root,controller);

      const on=(target,type,handler,options={})=>{
        if(!target)return;

        target.addEventListener(type,handler,{
          ...(typeof options==="boolean"
            ?{capture:options}
            :options),
          signal:controller.signal
        });
      };

      mountEyewear(root,products,ui,on);
      mountAccessories(root,products,ui,on);
      mountJourneys(root,products,ui,on);
      mountCollector(root,products,ui,on);
    });
  }
}

document.addEventListener("click",event=>{
  const target=event.target.closest?.(
    ".ccx10 button,.ccx10 a,.ccx10 dialog"
  );

  if(!target)return;

  const productButton=event.target.closest("[data-product]");

  if(productButton){
    event.preventDefault();
    if(productButton.id === "ccx10-eyewear-explore" || productButton.closest("#ccx10-accessories")){
      const productURL = products[productButton.dataset.product]?.url;
      if(productURL) window.location.assign(productURL);
    }else{
      openProduct(productButton.dataset.product,productButton);
    };
    return;
  }

  const close=event.target.closest(".ccx10-dialog-close");

  if(close){
    close.closest("dialog")?.close();
    return;
  }

  const detail=event.target.closest("[data-detail]");

  if(detail){
    const image=detail.querySelector("img");
    const dialog=one("#ccx10-detail-dialog");

    if(!image||!dialog)return;

    setImage(one("#ccx10-detail-image"),image.src,image.alt);

    one(".ccx10-detail-image-wrap").classList.toggle(
      "ccx10-is-rotated",
      detail.classList.contains("ccx10-rotate-photo")
    );

    one("#ccx10-detail-title").textContent=
      detail.dataset.title||image.alt;

    one("#ccx10-detail-caption").textContent=
      detail.dataset.caption||"";

    one("#ccx10-detail-original").href=image.src;

    openDialog(dialog,detail);
    return;
  }

  const film=event.target.closest("[data-film]");

  if(film){
    openDialog(filmDialog(),film);
    one("#ccx10-full-film")?.play().catch(()=>{});
    return;
  }

  if(target.id==="ccx10-ambient-toggle"){
    const video=one("#ccx10-ambient-film");
    if(!video)return;

    if(video.paused){
      video.play().then(()=>{
        target.textContent=say("pause_background");
        target.setAttribute("aria-label",say("pause_background"));
      }).catch(()=>{});
    }else{
      video.pause();
      target.textContent=say("play_background");
      target.setAttribute("aria-label",say("play_background"));
    }

    return;
  }

  if(target.id==="ccx10-compare-button"){
    const area=one("#ccx10-comparison");

    if(area){
      area.hidden=!area.hidden;
      target.setAttribute("aria-expanded",String(!area.hidden));
      target.querySelector("span").textContent=area.hidden?"+":"−";
    }

    return;
  }

  if(target.id==="ccx10-cloth-turn"){
    const back=target.getAttribute("aria-pressed")!=="true";
    target.setAttribute("aria-pressed",String(back));

    const photo=one("#ccx10-cloth-image");
    const data=target.closest(".ccx10").querySelector(
      "[data-ccx10-cloth]"
    );

    if(data){
      const sides=JSON.parse(data.textContent);
      const side=back?sides.back:sides.front;

      setImage(photo,side.src,side.alt);
      target.querySelector("[data-cloth-label]").textContent=side.label;
      photo.closest("button").dataset.title=side.title;
    }

    return;
  }

  const jump=event.target.closest("[data-jump-unveil]");

  if(jump){
    const destination=document.querySelector(
      jump.getAttribute("href")
    );

    if(destination){
      event.preventDefault();
      productDialog()?.close();

      requestAnimationFrame(()=>{
        destination.scrollIntoView({block:"start"});
        destination.querySelector("h2,h3")?.focus({
          preventScroll:true
        });
      });
    }

    return;
  }

  if(target.matches("dialog")&&target.open){
    const rect=target.getBoundingClientRect();

    if(
      event.clientX<rect.left||
      event.clientX>rect.right||
      event.clientY<rect.top||
      event.clientY>rect.bottom
    ){
      target.close();
    }
  }
});

document.addEventListener("close",event=>{
  if(!event.target.matches?.(".ccx10 dialog"))return;

  if(event.target===filmDialog()){
    one("#ccx10-full-film")?.pause();
  }

  if(!one("dialog[open]")){
    document.body.classList.remove("ccx10-modal-open");
  }

  if(lastTrigger?.isConnected){
    lastTrigger.focus({preventScroll:true});
  }
},true);

document.addEventListener("visibilitychange",()=>{
  if(document.hidden)pauseMedia();
});

document.addEventListener("shopify:section:load",()=>init(true));

document.addEventListener("shopify:section:unload",event=>{
  const root=event.target.closest?.(".ccx10")||
    event.target.querySelector?.(".ccx10");

  if(!root)return;

  mounted.get(root)?.abort();
  mounted.delete(root);
  root.querySelectorAll("video").forEach(video=>video.pause());

  if(root.querySelector("[data-ccx10-config]")){
    root.querySelectorAll("dialog[open]").forEach(dialog=>{
      dialog.close();
    });

    document.body.classList.remove("ccx10-modal-open");
  }
});

window.CCXFrequency10={init};

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",()=>init(),{
    once:true
  });
}else{
  init();
}

function mountEyewear(root,products2,ui2,on){
  const reduced=matchMedia("(prefers-reduced-motion: reduce)");
  const theatre=root.querySelector("#ccx10-eyewear-theatre");

  if(!theatre)return;

  const panel=theatre.querySelector("#ccx10-eyewear-panel");
  const image=theatre.querySelector("#ccx10-eyewear-image");

  const modelTabs=[
    ...theatre.querySelectorAll("[data-eyewear-model]")
  ];

  const viewButtons=[
    ...theatre.querySelectorAll("[data-eyewear-view]")
  ];

  const copy={
    ride:products2.ride.copy,
    vibe:products2.vibe.copy
  };

  let model="ride";
  let view="front";
  let imageRequest=0;

  function updateImage(){
    const request=++imageRequest;
    const key=model;
    const angle=view;

    const alt=say("image_"+angle,{
      name:products2[key].title
    });

    image.classList.add("ccx10-changing");
    panel.setAttribute("aria-busy","true");

    const next=new Image;

    next.onload=()=>{
      if(request!==imageRequest)return;

      image.src=next.src;
      image.alt=alt;
      image.classList.remove("ccx10-changing");
      panel.removeAttribute("aria-busy");

      theatre.querySelector("#ccx10-eyewear-status").textContent=alt;
    };

    next.onerror=()=>{
      if(request!==imageRequest)return;

      image.classList.remove("ccx10-changing");
      panel.removeAttribute("aria-busy");

      theatre.querySelector("#ccx10-eyewear-status").textContent=
        say("image_error");
    };

    next.src=products2[key].views[angle];
  }

  function selectModel(key,moveFocus=false){
    model=key;
    view="front";

    const p=products2[key];
    const wording=copy[key];
    const edition=theatre.querySelector(".ccx10-eyewear-edition");

    if(edition){
      edition.querySelector("strong").textContent=p.edition;

      edition.querySelector("span").replaceChildren(
        document.createTextNode(
          say("worldwide_count",{count:p.edition})
        ),
        document.createElement("br"),
        document.createTextNode(say("numbered"))
      );
    }

    modelTabs.forEach(tab=>{
      const active=tab.dataset.eyewearModel===key;
      tab.setAttribute("aria-selected",String(active));
      tab.tabIndex=active?0:-1;

      if(active&&moveFocus)tab.focus();
    });

    panel.dataset.model=key;
    panel.dataset.view=view;
    panel.setAttribute("aria-labelledby","ccx10-eyewear-tab-"+key);

    theatre.querySelector("#ccx10-eyewear-ghost").textContent=p.title;

    theatre.querySelector("#ccx10-eyewear-number").textContent=
      "NUMBERED EYEWEAR / "+p.title;

    theatre.querySelector("#ccx10-eyewear-heading").replaceChildren(
      document.createTextNode(wording.title[0]),
      document.createElement("br"),
      document.createTextNode(wording.title[1])
    );

    theatre.querySelector("#ccx10-eyewear-description").textContent=
      wording.description;

    theatre.querySelector("#ccx10-eyewear-model-name").textContent=
      p.title;

    theatre.querySelector("#ccx10-eyewear-model-price").textContent=
      p.price;

    const explore=theatre.querySelector("#ccx10-eyewear-explore");
    const open=theatre.querySelector("#ccx10-eyewear-image-open");

    explore.dataset.product=key;
    open.dataset.product=key;

    open.setAttribute("aria-label",say("explore_name",{
      name:p.title
    }));

    const arrow=document.createElement("span");
    arrow.setAttribute("aria-hidden","true");
    arrow.textContent="↗";

    explore.replaceChildren(
      document.createTextNode(say("secure_name",{name:p.title})+" "),
      arrow
    );

    viewButtons.forEach(button=>{
      button.hidden=!p.views[button.dataset.eyewearView];
      button.disabled=button.hidden;

      button.setAttribute(
        "aria-pressed",
        String(button.dataset.eyewearView===view)
      );
    });

    updateImage();
  }

  modelTabs.forEach((tab,index)=>{
    on(tab,"click",()=>selectModel(tab.dataset.eyewearModel));

    on(tab,"keydown",event=>{
      if(!["ArrowLeft","ArrowRight","Home","End"].includes(event.key)){
        return;
      }

      event.preventDefault();

      selectModel(
        event.key==="Home"
          ?"ride"
          :event.key==="End"
            ?"vibe"
            :modelTabs[(index+1)%modelTabs.length].dataset.eyewearModel,
        true
      );
    });
  });

  viewButtons.forEach(button=>{
    on(button,"click",()=>{
      view=button.dataset.eyewearView;
      panel.dataset.view=view;

      viewButtons.forEach(other=>{
        other.setAttribute("aria-pressed",String(other===button));
      });

      updateImage();
    });
  });

  if(
    !reduced.matches&&
    matchMedia("(hover:hover) and (pointer:fine)").matches
  ){
    on(panel,"pointermove",event=>{
      const rect=panel.getBoundingClientRect();

      panel.style.setProperty(
        "--eyewear-x",
        ((event.clientX-rect.left)/rect.width-.5)*3+"deg"
      );

      panel.style.setProperty(
        "--eyewear-y",
        -((event.clientY-rect.top)/rect.height-.5)*2+"deg"
      );
    },{passive:true});

    on(panel,"pointerleave",()=>{
      panel.style.removeProperty("--eyewear-x");
      panel.style.removeProperty("--eyewear-y");
    });
  }

  selectModel("ride");
}

function mountAccessories(root,products2,ui2,on){
  const keys=["bracelet","chain","visor","mask"];
  const section=root.querySelector("#ccx10-accessories");

  if(!section)return;

  const tabs=[...section.querySelectorAll("[data-accessory]")];
  const art=section.querySelector("#ccx10-accessory-art");
  const image=section.querySelector("#ccx10-accessory-image");
  const explore=section.querySelector("#ccx10-accessory-explore");

  let selected=0;
  let request=0;
  let touch=null;

  function select(index,moveFocus=false){
    selected=(index+keys.length)%keys.length;

    const key=keys[selected];
    const p=products2[key];
    const id=++request;

    tabs.forEach((tab,i)=>{
      const active=i===selected;
      tab.setAttribute("aria-selected",String(active));
      tab.tabIndex=active?0:-1;

      if(active&&moveFocus)tab.focus();
    });

    section.querySelector("#ccx10-accessory-panel").setAttribute(
      "aria-labelledby",
      "ccx10-accessory-tab-"+key
    );

    section.querySelector("#ccx10-accessory-name").textContent=p.title;

    section.querySelector("#ccx10-accessory-description").textContent=
      p.description;

    section.querySelector("#ccx10-accessory-price").textContent=p.price;

    section.querySelector("#ccx10-accessory-edition").textContent=
      say("limited_count",{count:p.edition});

    section.querySelector("#ccx10-accessory-count").textContent=
      String(selected+1).padStart(2,"0");

    section.querySelector("#ccx10-accessory-outline").textContent=
      String(selected+1).padStart(2,"0");

    section.querySelector("#ccx10-accessory-status").textContent=
      say("accessory_status",{
        name:p.title,
        edition:p.edition,
        index:selected+1
      });

    explore.dataset.product=key;

    const arrow=document.createElement("span");
    arrow.setAttribute("aria-hidden","true");
    arrow.textContent="↗";

    explore.replaceChildren(
      document.createTextNode(say("explore_name",{name:p.title})+" "),
      arrow
    );

    art.classList.add("ccx10-changing");

    const next=new Image;

    next.onload=()=>{
      if(id!==request)return;

      image.src=next.src;
      image.alt=say("accessory_alt",{name:p.title});
      art.dataset.object=key;
      art.classList.remove("ccx10-changing");
    };

    next.onerror=()=>{
      if(id!==request)return;

      art.classList.remove("ccx10-changing");

      section.querySelector("#ccx10-accessory-status").textContent=
        say("image_error");
    };

    next.src=p.views.front;
  }

  tabs.forEach((tab,index)=>{
    on(tab,"click",()=>select(index));

    on(tab,"keydown",event=>{
      if(!["ArrowLeft","ArrowRight","Home","End"].includes(event.key)){
        return;
      }

      event.preventDefault();

      select(
        event.key==="Home"
          ?0
          :event.key==="End"
            ?keys.length-1
            :selected+(event.key==="ArrowRight"?1:-1),
        true
      );
    });
  });

  on(
    section.querySelector("#ccx10-accessory-prev"),
    "click",
    ()=>select(selected-1)
  );

  on(
    section.querySelector("#ccx10-accessory-next"),
    "click",
    ()=>select(selected+1)
  );

  on(art,"pointerdown",event=>{
    if(event.pointerType!=="mouse"){
      touch={x:event.clientX,y:event.clientY};
    }
  },{passive:true});

  on(art,"pointerup",event=>{
    if(!touch)return;

    const dx=event.clientX-touch.x;
    const dy=event.clientY-touch.y;
    touch=null;

    if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4){
      select(selected+(dx<0?1:-1));
    }
  },{passive:true});

  on(art,"pointercancel",()=>{
    touch=null;
  },{passive:true});

  select(0);
}

function mountJourneys(root,products2,ui2,on){
  root.querySelectorAll("[data-journey]").forEach(journey=>{
    const tabs=[...journey.querySelectorAll('[role="tab"]')];
    const panels=[...journey.querySelectorAll('[role="tabpanel"]')];
    const previous=journey.querySelector("[data-previous]");
    const next=journey.querySelector("[data-next]");
    const count=journey.querySelector("[data-step-count]");

    let current=0;

    function select(index,moveFocus=false){
      current=Math.max(0,Math.min(index,tabs.length-1));

      tabs.forEach((tab,i)=>{
        tab.setAttribute("aria-selected",String(i===current));
        tab.tabIndex=i===current?0:-1;
        panels[i].hidden=i!==current;
      });

      previous.disabled=current===0;

      next.querySelector("[data-next-label]").textContent=
        current===tabs.length-1?say("start_again"):say("next");

      count.textContent=
        String(current+1).padStart(2,"0")+
        " / "+
        String(tabs.length).padStart(2,"0");

      if(moveFocus){
        panels[current].focus({preventScroll:true});
      }
    }

    function advance(){
      select(current===tabs.length-1?0:current+1,true);

      if(matchMedia("(max-width: 650px)").matches){
        panels[current].scrollIntoView({block:"start"});
      }
    }

    tabs.forEach((tab,index)=>{
      on(tab,"click",()=>select(index));

      on(tab,"keydown",event=>{
        let target;

        if(event.key==="ArrowRight"){
          target=(index+1)%tabs.length;
        }else if(event.key==="ArrowLeft"){
          target=(index-1+tabs.length)%tabs.length;
        }else if(event.key==="Home"){
          target=0;
        }else if(event.key==="End"){
          target=tabs.length-1;
        }else{
          return;
        }

        event.preventDefault();
        select(target);
        tabs[target].focus();
      });
    });

    on(previous,"click",()=>{
      select(current-1,true);

      if(matchMedia("(max-width: 650px)").matches){
        panels[current].scrollIntoView({block:"start"});
      }
    });

    on(next,"click",advance);

    journey.querySelectorAll("[data-advance]").forEach(button=>{
      on(button,"click",advance);
    });

    select(0);
  });
}

function mountCollector(root,products2,ui2,on){
  const carousel=root.querySelector("#ccx10-collector-carousel");
  if(!carousel)return;

  const viewport=carousel.querySelector(
    ".ccx10-collector-carousel-viewport"
  );

  const slides=[
    ...carousel.querySelectorAll(".ccx10-collector-piece")
  ];

  const indicators=[
    ...carousel.querySelectorAll("[data-collector-index]")
  ];

  const reduced=matchMedia("(prefers-reduced-motion: reduce)");

  let selected=0;
  let gesture=null;
  let suppressClickUntil=0;

  function select(index,direction=1){
    const next=(index+slides.length)%slides.length;
    if(next===selected)return;

    const moveFocus=slides[selected].contains(document.activeElement);
    selected=next;

    viewport.style.removeProperty("--collector-drag");

    viewport.style.setProperty(
      "--collector-enter",
      (direction<0?-22:22)+"px"
    );

    slides.forEach((slide,i)=>{
      slide.hidden=i!==selected;
      slide.classList.remove("ccx10-is-entering");
    });

    const active=slides[selected];

    if(!reduced.matches){
      active.classList.add("ccx10-is-entering");
    }

    indicators.forEach((button,i)=>{
      button.setAttribute("aria-pressed",String(i===selected));
    });

    carousel.querySelector("#ccx10-collector-piece-name").textContent=
      active.dataset.name;

    carousel.querySelector("#ccx10-collector-piece-note").textContent=
      active.dataset.note;

    carousel.querySelector("#ccx10-collector-piece-count").textContent=
      String(selected+1).padStart(2,"0");

    carousel.querySelector("#ccx10-collector-carousel-status").textContent=
      say("carousel_status",{
        name:active.dataset.name,
        index:selected+1
      });

    if(moveFocus){
      active.querySelector("button").focus({preventScroll:true});
    }

    const upcoming=slides[(selected+1)%slides.length].querySelector("img");
    const preload=new Image;
    preload.src=upcoming.src;
  }

  on(
    carousel.querySelector("[data-collector-prev]"),
    "click",
    ()=>select(selected-1,-1)
  );

  on(
    carousel.querySelector("[data-collector-next]"),
    "click",
    ()=>select(selected+1,1)
  );

  indicators.forEach((button,index)=>{
    on(button,"click",()=>select(
      index,
      index<selected?-1:1
    ));
  });

  on(carousel,"keydown",event=>{
    if(
      event.altKey||
      event.ctrlKey||
      event.metaKey||
      event.shiftKey
    ){
      return;
    }

    let target;

    if(event.key==="ArrowLeft"){
      target=selected-1;
    }else if(event.key==="ArrowRight"){
      target=selected+1;
    }else if(event.key==="Home"){
      target=0;
    }else if(event.key==="End"){
      target=slides.length-1;
    }else{
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    select(target,target<selected?-1:1);
  });

  on(viewport,"pointerdown",event=>{
    if(event.isPrimary===false)return;
    if(event.pointerType==="mouse"&&event.button!==0)return;

    gesture={
      id:event.pointerId,
      x:event.clientX,
      y:event.clientY,
      dx:0,
      horizontal:false
    };

    suppressClickUntil=0;
  },{passive:true});

  on(viewport,"pointermove",event=>{
    if(!gesture||gesture.id!==event.pointerId)return;

    const dx=event.clientX-gesture.x;
    const dy=event.clientY-gesture.y;

    if(!gesture.horizontal){
      if(Math.abs(dy)>12&&Math.abs(dy)>Math.abs(dx)){
        gesture=null;
        return;
      }

      if(
        Math.abs(dx)<12||
        Math.abs(dx)<Math.abs(dy)*1.25
      ){
        return;
      }

      gesture.horizontal=true;
      viewport.classList.add("ccx10-is-dragging");
      viewport.setPointerCapture?.(event.pointerId);
    }

    gesture.dx=dx;

    if(event.cancelable)event.preventDefault();

    const limit=(viewport.clientWidth||400)*.24;

    viewport.style.setProperty(
      "--collector-drag",
      Math.max(-limit,Math.min(limit,dx*.55))+"px"
    );
  });

  function finish(event,cancelled=false){
    if(!gesture||gesture.id!==event.pointerId)return;

    const last=gesture;
    gesture=null;

    viewport.classList.remove("ccx10-is-dragging");
    viewport.style.removeProperty("--collector-drag");

    if(viewport.hasPointerCapture?.(event.pointerId)){
      viewport.releasePointerCapture(event.pointerId);
    }

    const dx=Number.isFinite(event.clientX)
      ?event.clientX-last.x
      :last.dx;

    const minimum=Math.min(
      72,
      Math.max(36,(viewport.clientWidth||400)*.11)
    );

    if(last.horizontal){
      suppressClickUntil=performance.now()+400;
    }

    if(!cancelled&&last.horizontal&&Math.abs(dx)>=minimum){
      select(selected+(dx<0?1:-1),dx<0?1:-1);
    }
  }

  on(viewport,"pointerup",event=>finish(event));
  on(viewport,"pointercancel",event=>finish(event,true));
  on(viewport,"lostpointercapture",event=>finish(event,true));

  on(viewport,"pointerleave",event=>{
    if(gesture&&!gesture.horizontal&&event.pointerType==="mouse"){
      gesture=null;
    }
  });

  on(viewport,"click",event=>{
    if(performance.now()<suppressClickUntil){
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },true);

  on(viewport,"dragstart",event=>event.preventDefault());
}
})();